import type { EditControlProps } from '../../declare'
import { Input } from 'antd'
import { $consts } from 'src/plugins'

const TextInput = (props: EditControlProps) => {
  const handleChange = (evt: any) => {
    props.onChange?.(evt.target.value)
  }

  const { __READONLY__, CONTROL_TYPE } = props.config
  if (CONTROL_TYPE === $consts['TABLE/CONTROL_TYPE_TEXTAREA']) {
    return (
      <Input.TextArea
        disabled={__READONLY__}
        rows={2}
        autoSize={false}
        value={props.value}
        onChange={handleChange}
        style={{ minWidth: 220, resize: 'none' }}
      />
    )
  }
  return <Input disabled={__READONLY__} value={props.value} onChange={handleChange} />
}

export default TextInput